import { Tile } from "../Tile";
import { Game } from "../Game";

export class MockTile implements Tile {
  public game?: Game | undefined;
}
